export const FooterSpacer = () => {
    return <div className="h-32 bg-[#040F0F]"></div>;
  };